import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cloud-home",
  "use": "icon-cloud-home-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cloud-home\">\r\n  \r\n  <!-- cloud（再放大） -->\r\n  <path d=\"M5 19h13a4.5 4.5 0 1 0-.7-9 6.5 6.5 0 0 0-12 2A4.5 4.5 0 0 0 5 19z\" />\r\n  \r\n  <!-- home（同步放大） -->\r\n  <path d=\"M8 19v-4l4-2.8 4 2.8v4\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol